import type { VaultPlainItem } from '../types/vault.types.js';

export interface VaultRevealDecision {
    allowed: boolean;
    reason?: string;
    message?: string;
}

export class VaultPolicyService {
    evaluateReveal(item: VaultPlainItem, reason?: string): VaultRevealDecision {
        if (item.containsSecret === false) {
            return { allowed: true, reason };
        }
        if (item.sensitivity !== 'secret') {
            return { allowed: true, reason };
        }
        if (!reason || reason.trim().length < 6) {
            return {
                allowed: false,
                message: 'Secret reveal requires --reason with a clear operational reason.',
            };
        }
        return { allowed: true, reason };
    }
}
